/**
 * @generated SignedSource<<6010b3662d3f701a89cb94c797f6c0b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CourtsControlFragment$data = {
  readonly agenda: {
    readonly facility: {
      readonly copyOverrides: {
        readonly course: {
          readonly singular: string;
        } | null | undefined;
      };
    };
  };
  readonly course?: {
    readonly description: string | null | undefined;
    readonly id: string;
    readonly name: string;
  };
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"useGetCourseOptionsFromValidCustomerBookingSelections_TimeSlot">;
  readonly " $fragmentType": "CourtsControlFragment";
};
export type CourtsControlFragment$key = {
  readonly " $data"?: CourtsControlFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CourtsControlFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CourtsControlFragment",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useGetCourseOptionsFromValidCustomerBookingSelections_TimeSlot"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Course",
          "kind": "LinkedField",
          "name": "course",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "TimeSlot",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Agenda",
      "kind": "LinkedField",
      "name": "agenda",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Facility",
          "kind": "LinkedField",
          "name": "facility",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FacilityCopyOverrides",
              "kind": "LinkedField",
              "name": "copyOverrides",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NounOverride",
                  "kind": "LinkedField",
                  "name": "course",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "singular",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Slot",
  "abstractKey": "__isSlot"
};
})();

(node as any).hash = "563ad5d3766da31fc23cd7b652ca3a10";

export default node;
